<template>
  <div>
    <div class="body1">{{ $t("modals.removeCustomDomainDns.description") }}</div>
    <div class="body1 mt-3" v-for="item in config.item" :key="item.id">
      {{ item.domain }}
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";
import type { DialogDataConfig } from "@/_store/dialogs.module";

export default defineComponent({
  props: {
    config: {
      type: Object as PropType<DialogDataConfig>,
      required: true,
    },
  },
});
</script>

<style lang="scss" scoped></style>
